'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const TablePublicationHoverIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={12} cy={12} r={6} fill="#7C52DE" stroke="#fff" strokeWidth={2} /></svg>);